function browserType() {
  var system = {
    win: false,
    mac: false,
    x11: false,
    ipad: false,
  };
  //检测平台
  var p = navigator.platform;
  system.win = p.indexOf("Win") == 0;
  system.mac = p.indexOf("Mac") == 0;
  system.x11 = p == "X11" || p.indexOf("Linux") == 0;
  system.ipad = navigator.userAgent.match(/iPad/i) != null ? true : false;

  if (system.win || system.mac || system.x11 || system.ipad) {
    return "pc";
  } else {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return "weixin";
    } else {
      return "mobile";
    }
  }
}
export default browserType;